import { getErrorDetail } from "components/utility/utils";
import { fetchOrchidAPI } from "utils/api";

export default async function querySessionTypes(onBehalfOf?: string) {
  const response = await fetchOrchidAPI(
    `/api/scheduler/v1/appointment_types/${
      onBehalfOf ? `?on_behalf_of=${onBehalfOf}` : ""
    }`,
  );
  if (!response.ok) {
    throw new Error(getErrorDetail(await response.text()));
  }

  const res: SessionType[] = (await response.json()) || [];
  return res;
}
